export const ALERTING = 'ALERTING'